import styled from 'styled-components'
import SyfLoader from 'syf-component-library/ui/atoms/Loader/SyfLoader'

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  align-items: center;
  justify-content: center;
`

export const SyfLoaderIcon = styled(SyfLoader)`
  width: 31px;
  height: 40px;
`

const Loader = () => (
  <LoadingContainer>
    <SyfLoaderIcon />
  </LoadingContainer>
)

export default Loader
